module.exports = __webpack_public_path__ + "img/MBOMinsertanvil-min.23e9f431.png";